<script lang="ts" setup>
import TabContent from "~/components/TabContent.vue";
import TabChartOfStandards from "~/components/product/TabChartOfStandards.vue";
import TabTableOfContents from "~/components/product/TabTableOfContents.vue";
import TabTeachersGuide from "~/components/product/TabTeachersGuide.vue";
import TabCwOnlineTesting from "~/components/product/TabCwOnlineTesting.vue";

// Properties
const props = defineProps({
    product: {
        type: Object,
    },
});

// Data
const tabs = [
    { key: "tableOfContents", label: "Table of Contents" },
    //{key: 'chartOfStandards', label: 'Chart of Standards'}, // Hide chart ot standards for now
    { key: "teacherGuide", label: "Teacher Guide" },
    { key: "cwOnlineTesting", label: "CourseWave Online Testing" },
];
</script>

<template>
    <div>
        <div>
            <TabContent :tabs="tabs">
                <template #tableOfContents>
                    <TabTableOfContents :product="product" />
                </template>
                <template #chartOfStandards>
                    <TabChartOfStandards />
                </template>
                <template #teacherGuide>
                    <TabTeachersGuide />
                </template>
                <template #cwOnlineTesting="scope">
                    <TabCwOnlineTesting :click-tab="scope.clickTab" />
                </template>
            </TabContent>
        </div>
    </div>
</template>

<style scoped></style>
